export const AMPLITUDE_STAGING_API_KEY = '7aef95e5e44ae05b2e2fa02a9e47945f';
export const AMPLITUDE_PRODUCTION_API_KEY = 'bf7847a8cd4ac5744828d295db74cffa';
